export default __webpack_public_path__ + "static/media/C-003.b7cc7c57.png";